import moment from 'moment';

import { Box, Text } from '@frontend/components';
import { useDateFormat } from '@frontend/utils';

import { toReadableString } from 'utils/stringUtils';

import HighlightOrDisplay from './HighlightOrDisplay';
import LabelText from './LabelText';
import ValueText from './ValueText';

const PaddedCell = ({ children }) => (
  <td style={{ paddingRight: '8px' }}>{children}</td>
);

const QuoteMatchCell = ({ quoteResult }) => {
  const { dateAtTimeFormat } = useDateFormat();
  return (
    <Box
      as="a"
      display="block"
      width="100%"
      height="100%"
      href={`/quotes/edit/${quoteResult.data.number}`}
      transition="0.2s ease"
      _hover={{
        bg: 'interaction.surfaceHover',
      }}
      _focus={{
        boxShadow: 'focusInset',
      }}
      _active={{
        bg: 'interaction.surfaceActive',
      }}
      padding={1}
    >
      <Box as="table" borderCollapse="collapse">
        <tbody>
          <tr>
            <PaddedCell>
              <Text
                fontFamily="data"
                fontSize="sm"
                fontWeight="heavy"
                color="feature.primary"
              >
                {`Quote #`}
                <HighlightOrDisplay
                  result={quoteResult}
                  field="number"
                  textProps={{ fontWeight: 'heavy' }}
                  useDataFont
                />
              </Text>
            </PaddedCell>
            <td>
              <LabelText>{toReadableString(quoteResult.data.status)}</LabelText>
            </td>
          </tr>
          <tr>
            <PaddedCell>
              <LabelText>CONTACT</LabelText>
            </PaddedCell>
            <td>
              <HighlightOrDisplay result={quoteResult} field="accountName" />
            </td>
          </tr>
          <tr>
            <PaddedCell />
            <td>
              <HighlightOrDisplay
                result={quoteResult}
                field="contactFullName"
              />
            </td>
          </tr>
          <tr>
            <PaddedCell />
            <td>
              <HighlightOrDisplay result={quoteResult} field="contactEmail" />
            </td>
          </tr>
          <tr>
            <PaddedCell>
              <LabelText>PRICING</LabelText>
            </PaddedCell>
            <td>
              <ValueText
                useDataFont
              >{`$${quoteResult.data.minimumTotal} - $${quoteResult.data.maximumSubtotal}`}</ValueText>
            </td>
          </tr>
          <tr>
            <PaddedCell>
              <LabelText>CREATED</LabelText>
            </PaddedCell>
            <td>
              <ValueText useDataFont>
                {quoteResult.data.created
                  ? moment(quoteResult.data.created)
                      .subtract(new Date().getTimezoneOffset(), 'minutes')
                      .format(dateAtTimeFormat)
                  : '--'}
              </ValueText>
            </td>
          </tr>
          <tr>
            <PaddedCell>
              <LabelText>DUE</LabelText>
            </PaddedCell>
            <td>
              <ValueText useDataFont>
                {quoteResult.data.dueDate
                  ? moment(quoteResult.data.dueDate)
                      .subtract(new Date().getTimezoneOffset(), 'minutes')
                      .format(dateAtTimeFormat)
                  : '--'}
              </ValueText>
            </td>
          </tr>
          <tr>
            <PaddedCell>
              <LabelText>EXPIRES</LabelText>
            </PaddedCell>
            <td>
              <ValueText useDataFont>
                {quoteResult.data.expiredDate
                  ? moment(quoteResult.data.expiredDate)
                      .subtract(new Date().getTimezoneOffset(), 'minutes')
                      .format(dateAtTimeFormat)
                  : '--'}
              </ValueText>
            </td>
          </tr>
        </tbody>
      </Box>
    </Box>
  );
};

export default QuoteMatchCell;
